<template>
  <section>
    <b-modal :active.sync="isModalSearch">
      <div class="card" style="border-radius: 10px;">
        <header class="card-header">
          <p class="card-header-title title">
            検索結果
          </p>
        </header>
        <div class="card-content parent-box">
          <div class="box-request">
            <!--●sarch word not found -->
            <div v-if="searchResult.noResult===true">
                <p>マッチする検索結果はありません。</p>
                <p>ダイレクトトーク名(訪問者名、メッセージ内容)、ロボ名(またはシナリオ名)を入力して下さい。</p>
            </div>

            <span v-for="(record,key) in searchResult.record"  :key="key">
              <p>●●●{{key}}件目●●●</p>
                <!--●section of Seeker result-->              
                  <div v-if="record.db_model==='Seeker'">
                    <button class="button is-primary" @click="directTalkQuertUrl(record.name)">訪問者画面表示(最新順)</button>
                    <div style="border-radius: 2px; background: #f2f2f2; width: 100%; padding: 10px; margin: 20px; border: 3px ">
                      <div>
                          名前:
                          <span v-for="(word, key2) in highLight(record.name, searchResult.serachword)" :key="key2"
                                :class="{'highlight': word == searchResult.serachword}"
                                class="shortfontwidth">
                              {{word}}
                          </span>
                      </div>
                      <div>
                          作成日:
                          <span v-for="(word, key2) in highLight(record.created_at, searchResult.serachword)" :key="key2"
                          :class="{'highlight': word == searchResult.serachword}"
                                class="shortfontwidth">
                              {{word}}
                          </span>
                      </div>
                    </div>   
                  </div>  
                 
                  <!--●section of Seeker of message result-->   
                  <!-- 検索結果が多すぎますと、伝える -->
                    <div v-if="record.db_model==='Seeker_Messages'">
                      <button class="button is-primary" @click="directTalkQuertUrl(record.messages.name)">訪問者メッセージ(最新順) : {{record.messages.name}}</button>
                      <!-- <button class="button is-primary" @click="directTalkQuertUrl(record.messages.name)" style="height:20px;padding: 0px;line-height:1px;font-size:15px;">{{record.messages.count}}：{{record.messages.name}}</button><br> -->                      
                      <div style="border-radius: 2px; background: #f2f2f2; width: 100%; padding: 10px; margin: 20px; border: 3px ">
                        <div>
                            メッセージ:（最新順）<br>
                              <div style='margin-left: 13px;'>
                                <span v-for="(word, key3) in record.messages.messages_alt" :key="key3" class="shortfontwidth">
                                  <button class="button is-primary" @click="directTalkMessage(word.id,record.messages.name)" style="height:20px;padding: 0px;line-height:1px;font-size:15px;">{{key3+1}}メッセージ目</button><br>                                      
                                  <!-- 会話:{{word.message}}<br> -->
                                  会話:
                                  <span v-for="(word_message, key_message) in highLight(word.message, searchResult.serachword)" :key="key_message" 
                                        :class="{'highlight': word_message == searchResult.serachword}"
                                        class="shortfontwidth">
                                      {{word_message}}
                                  </span><br>      

                                  作成日:{{word.created_at}}<br>
                                </span>
                              </div>
                        </div>
                      </div>   
                    </div>

              <!--●section of ChatBot result-->
              <div v-if="record.db_model==='ChatBot'">
                <button class="button is-primary" @click="chatBotQuertUrl(record.name)">ロボ画面表示</button>              
                <div style="border-radius: 2px; background: #f2f2f2; width: 100%; padding: 10px; margin: 20px; border: 3px ">
                  <div>
                      名前:
                      <span v-for="(word, key2) in highLight(record.name, searchResult.serachword)" :key="key2" 
                            :class="{'highlight': word == searchResult.serachword}"
                            class="shortfontwidth">
                          {{word}}
                      </span>
                  </div>
                  <div>
                      シナリオ名:
                      <span v-for="(word, key2) in highLight(record.scenario_name , searchResult.serachword)" :key="key2" 
                            :class="{'highlight': word == searchResult.serachword}"
                            class="shortfontwidth">
                          {{word}}
                      </span>
                  </div>  
                  <div>
                      作成日:
                      <span v-for="(word, key2) in highLight(record.created_at, searchResult.serachword)" :key="key2" 
                            :class="{'highlight': word == searchResult.serachword}"
                            class="shortfontwidth">
                          {{word}}
                      </span>
                  </div>  
                  <div>
                      更新日:
                      <span v-for="(word, key2) in highLight(record.updated_at, searchResult.serachword)" :key="key2" 
                            :class="{'highlight': word == searchResult.serachword}"
                            class="shortfontwidth">
                          {{word}}
                      </span>
                  </div>
                </div>
              </div>
            </span>
          </div>
        </div>
      </div>
    </b-modal>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import DirectTalk from '@/views/DashBoard/DirectTalk/DirectTalk'

export default {
  name: 'Search',
  components: {
    DirectTalk
  },
  computed: {
    // disabled () {
    //   return this.title === '' || this.content === '' || this.email === '' || this.email.indexOf('@') <= 0
    // },
    ...mapState('auth', ['user', 'isModalRequestHelpSearch','searchResult']),
    ...mapState('directtalk', [ 'roomlist','chatLogs'] )
  },
  data () {
    return {
      isModalSearch: false,
      idd:'',
    }
  },
  watch: {
    isModalRequestHelpSearch: function () {
      // this.isModalSearch = this.isModalRequestHelpSearch
      this.isModalSearch = true   
    },
    isModalSearch: function () {
      this.isModalSearch ? 
      console.log('後２isModalSearch',this.isModalSearch) 
      :this.getSearch()
    },
    chatLogs : function(){  
      this.$store.dispatch('directtalk/scrollTalk',{'id':this.idd})
      // this.$router.push('/dashboard/directtalk')
      this.isModalSearch = false　
    }    
  },
  methods: {
    getSearch () {
      console.debug('*** Start *** getSearch')
      this.$store.dispatch('auth/getSearch')
      console.debug('*** End *** getSearch')
    },
    highLight (words, query){
      console.debug('*** Start *** highLight')
      var wordArr = []
      if (query) {
        console.info('query is not blank')
        //検索文字をカンマで囲む
        words = words.replace(query, ',' + query + ',')
        //最初と最後のカンマを削除
        words = words.replace(/^,/ , '').replace(/(,$)/ , '')
        //文字を配列にする。
        return words.split(',')
      } else{
        console.info('query is blank')
        return [words]
      }      
      console.debug('*** End *** highLight')
    },
    directTalkQuertUrl (name){
      console.debug('*** Start *** directTalkQuertUrl')
      console.debug('name: ' + name)
      this.$store.dispatch('auth/getQuery',{'name':name, 'urltype':'direct'})
      this.$router.push('/dashboard/directtalk')
      // (やること③)　前画面出たかをtrue false にして　this.isModalSearch = false　
      this.isModalSearch = false　
      console.debug('*** End *** directTalkQuertUrl')
    },
    chatBotQuertUrl (name){
      console.debug('*** Start *** chatBotQuertUrl')
      console.debug('name: ' + name)
      this.$store.dispatch('auth/getQuery',{'name':name, 'urltype':'chat'})
      this.$router.push('/dashboard/chatbot')
      this.isModalSearch = false　
      console.log('isModalSearch',this.isModalSearch) 
      console.debug('*** End *** chatBotQuertUrl')
    },
    directTalkMessage (id,name){
      console.debug('*** Start *** directTalkMessage')
      this.idd= id
      this.directTalkQuertUrl (name)
      console.debug('*** End *** directTalkMessage')
      
      // idはmountにしてもいいかwatchにしてもいい
      // this.$store.dispatch('directtalk/scrollTalk',{'id':id})
      // this.$router.push('/dashboard/directtalk')
      // this.isModalSearch = false　
    }    
  },
}
</script>

<style scoped>
.card {
  width: 400%;
}
.title {
  font-size: 24px;
  font-weight: 700;
  padding: 20px;
  border-bottom: solid thin #ccc;
}
.box-request {
  width: 100%;
  height: auto;
  padding: 20px;
  font-size: 15px;
  text-align: left;
}
.highlight{
    color: #ff0000;
    font-weight: bold;  
    /* letter-spacing: -2px;   */
}
.shortfontwidth{
  word-spacing: -3pt
}
</style>




// WEBPACK FOOTER //
// src/components/ui/Search.vue